import React, { useState } from "react";
import { Main, ThemedSpan } from "../../components/utilities";
import styled from "styled-components";
import ApplicationsGrid from "./components/ApplicationsGrid";
import {AdministrationDashboardFiltersModal, AdministrationDashboardFiltersModalButton} from "../administrationapplicationfilters";
import { useFilterContext } from "../../hooks/FilterContext";
import PageHeader from "../../components/layout/PageHeader";
import { AgGridMain, AdministrationDashboardPageSubHeader, ThemedIcon, ThemedParagraph } from "../../components/utilities";

const AdminDashboardHeaderTitle = styled.div`
    flex: 1;
    display: flex;
    font-size: 16px;

    & > span:not(:last-child) {
        margin-right: 1rem;
    }
`;

const AdminDashboardFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

const PageHeaderTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .75rem;
`;

const AdministrationApplications = () => {

    const [isFiltersShown, setIsFiltersShown] = useState(false);
    const {
        clearFilter,
        filter: { masterAccountIds },
        isFiltersApplied,
        setFilter,
    } = useFilterContext();

    return (
        <React.Fragment>
            <AdministrationDashboardFiltersModal
                handleClose={() => setIsFiltersShown(false)}
                show={isFiltersShown}
            />
            <PageHeader>
                <PageHeaderTop>
                    <AdminDashboardHeaderTitle>
                        <span>Advice Administration</span>
                    </AdminDashboardHeaderTitle>
                </PageHeaderTop>
            </PageHeader>
            <Main className="d-flex flex-column">
                <AdministrationDashboardPageSubHeader>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            {isFiltersApplied && (
                                <React.Fragment>
                                    <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                    <AdminDashboardFiltersAppliedWarningMessage className="ms-2 text-muted">
                                        Warning - Filters are currently being applied to your results.
                                        <br />
                                        <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                    </AdminDashboardFiltersAppliedWarningMessage>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                            <AdministrationDashboardFiltersModalButton
                                onClick={() => setIsFiltersShown(true)}
                            />
                        </div>
                    </div>
                </AdministrationDashboardPageSubHeader>
                <section className="px-4 my-3 h-100">
                    <ApplicationsGrid />
                </section>
            </Main>
        </React.Fragment>
    );
};


export default AdministrationApplications;
